import { useEffect } from 'react';
import { ApplicationContext, ApplicationProps } from '../useApplicationContext';
import { ApplicationStatus } from '../../../types';

export const useInitializeApplicationContext = (
  applicationProps: ApplicationProps,
): ApplicationContext => {
  const { actions, status } = applicationProps;

  useEffect(() => {
    if (status === ApplicationStatus.INITIALIZING) {
      actions.initializeWidget();
    }
  }, [status]);

  return { ...applicationProps };
};
